import {
    FETCH_RAINPRO_SELLERS,
    CLEAN_RAINPRO_SELLERS,
    CHANGE_RAINPRO_SELLER_EMAIL,
    CHANGE_RAINPRO_SELLER_SETTINGS,
} from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const RAINPRO_SELLERS_DEFAULT_STATE = {};

const RainproSellersReducer = (state = RAINPRO_SELLERS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_SELLERS:
            return payload;

        case CHANGE_RAINPRO_SELLER_EMAIL:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.user_id) === toNumber(payload.id)) {
                    item = { ...item, _matchingData: {
                        ...item._matchingData,
                        Users: { ...item._matchingData.Users, email: payload.email }
                    } };
                }

                return item;
            }) };

        case CHANGE_RAINPRO_SELLER_SETTINGS:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.user_id) === toNumber(payload.id)) {
                    item = { ...item, settings: payload.settings };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_SELLERS:
            return RAINPRO_SELLERS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproSellersReducer;
